import React from 'react';

// function formatDate(data) {
//     const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
//     const date = new Date(data);
//     return date.toLocaleDateString('fr-FR', options);
// }

function ERROR({messsage, color}) {
    return (<div style={{
        color: color
    }}>{messsage}</div>);
}

export default ERROR;
